/**
 * Helper utility to determine the correct API endpoint for opening PDD projects.
 * Since PDD projects can be created via TDD API and then marked as PDD,
 * all PDD projects should be opened using the TDD API endpoint.
 */

/**
 * Determines the correct API endpoint for opening a PDD project based on service line context
 * @param {Object} serviceLine - The service line object
 * @param {Object} projectData - Optional project data
 * @returns {string} - The API endpoint to use
 */
export const getPddOpenProjectApi = (serviceLine, projectData = null) => {
  if (serviceLine.name !== 'Pdd') {
    return serviceLine.api;
  }
  
  // Always use TDD API for PDD projects
  return 'tdd';
};
